<template>
  <el-dialog
    v-model="isVisible"
    class="country-restriction-dialog order-test"
    title="Country Restriction"
    append-to-body
    @close="close"
  >
    <div id="country-restriction-text-container">
      We serve patients worldwide, including regions such as the 🇬🇧 UK, 🇯🇵 Japan, and various parts of 🇪🇺 Europe, among others. For international shipments, please refer to the list below for any known country-specific restrictions.</div>
    <div id="country-restrict-table-container">
      <div id="country-restrict-table-header" class="flex items-center justify-center my-0.5 mt-5">
        <span class="w-1/5 ml-3">Country</span>
        <span class="w-2/5 flex justify-center">Shipment to Address</span>
        <span class="w-2/5 flex justify-center">Return to Vibrant</span>
      </div>
      <div class="mb-8">
        <el-scrollbar class="scroll-bar">
          <div 
            v-for="row in restrictList" 
            :key="row.id"
            class="country-restrict-table-rows flex items-center justify-center my-0.5"
          >
            <div class="w-1/5 flex items-center country-name ml-3">
              <img 
                :src="row.img"
                class="mr-1.5 country-img"
              >
              <span class="country-name-text">{{ row.name }}</span>
            </div>
            <div class="w-2/5 flex justify-center mx-16">
              <img
                v-if="row.shipTo==='x'"
                src="@/assets/orderTest/country_restriction/unavailable.svg" 
              >
              <img
                v-else-if="row.shipTo==='t'"
                src="@/assets/orderTest/country_restriction/available.svg" 
              >
              <span class="table-text" v-else>{{ row.shipTo }}</span>
            </div>
            <div class="w-2/5 flex justify-center mx-16">
              <img
                v-if="row.returnTo==='x'"
                src="@/assets/orderTest/country_restriction/unavailable.svg" 
              >
              <img
                v-else-if="row.returnTo==='t'"
                src="@/assets/orderTest/country_restriction/available.svg" 
              >
              <span class="table-text" v-else>{{ row.returnTo }}</span>
            </div>      
          </div> 
        </el-scrollbar>
      </div>
 
    </div>
    <div id="country-restriction-button-container " class="flex justify-end mr-2">
      <el-button 
        class="country-restriction-button" 
        @click="close"
      >
        Close
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { countryRestrictList } from "@/utils/va-order-test/index.js";
export default {
  props: {
    isShowCountryRestriction: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      isVisible: false,
      restrictList: countryRestrictList
    }
  },

  watch: {
    isShowCountryRestriction(newVal) {
      this.isVisible = newVal;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    findSVG(name) {
      // console.log("@/assets/orderTest/country_restriction/" + name + ".svg");
      return "@/assets/orderTest/country_restriction/" + name + ".svg"
    }
  },
}
</script>

<style scoped>
div#country-restrict-table-container {
  width: 506px;
}

div#country-restrict-table-header {
  width: 499px;
  height: 30px;
  background: #20A8C3;
  border: 1px solid #20A8C3;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;

  color: #FFFFFF;
}

div.country-restrict-table-rows{
  width: 499px;
  height: auto;
  padding: 10px 0px;
  min-height: 30px;
  background: #F8FAFB;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  letter-spacing: 0.4004px;

  color: #000000;  
}

div#country-restriction-button-container{
  width: 499px;
}

div#country-restriction-text-container{
  width: 506px;
  word-break: normal;
}


button.country-restriction-button{
  height: 42px;
  width: 139px;
  border-radius: 4px;
  background-color: #20A8C3;

  color: #FFFFFF;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.43px;
}

.scroll-bar {
  height: 400px;
}

.country-name {
  width: 120px;
  white-space: normal; 
  overflow-wrap: break-word;
  word-wrap: break-word; 
}

.country-img {
  width: 22px;
  height: 22px;
}

.table-text {
  text-align: center;
  word-break: break-word;
  white-space: normal;
}

.country-name-text {
  min-width: 100px;
  word-break: break-word;
  white-space: normal;
}
</style>